.#{$namespace}-textarea {
	position: relative;
	box-sizing: border-box;
	width: 100%;
	// 跟 Input 同一套：左右 padding 在外壳，内层铺满，字和拖角才不会各算各的
	display: inline-flex;
	// stretch：拖高之后内层跟着铺满，字从上面起；center 会把整段字吊在中间
	align-items: stretch;
	min-height: $control-height;
	padding-block: 0;
	// 右边不垫，滚动条才能贴边框；左边仍跟 Input 对齐
	padding-inline-start: calc($control-height * 0.45);
	padding-inline-end: 0;
	// 拖角写在外壳才能贴右下角；overflow 不能是 visible，否则原生 resize 不生效
	overflow: hidden;
	resize: vertical;
	border: 1px solid $border-color;
	border-radius: 8px;
	background-color: $white-color;
	textarea {
		// 0% 吃掉原生 cols 固有宽，flex:1 在部分内核仍按 20 列算
		flex: 1 1 0%;
		min-width: 0;
		box-sizing: border-box;
		width: 100%;
		margin: 0;
		appearance: none;
		// 上下靠填充把字和光标垫进框里，不要再 JS 量有没有滚动条
		padding-block: calc(($control-height - 2px - 1.5em) / 2);
		// 没条时右边跟 Input 一样留空，不然字贴边
		padding-inline: 0 calc($control-height * 0.45);
		border: none;
		outline: none;
		background: transparent;
		font-size: $font-size;
		line-height: 1.5;
		// 只留外壳一个拖角，内外一起拖会各拉各的
		resize: none;
		// 超出才出条，交给原生 auto，不要 .is-overflow
		overflow: auto;
	}
	.total-panel {
		position: absolute;
		top: 100%;
		right: 5px;
		font-size: calc($font-size - 2px);
		color: color-token(info);
		line-height: 1;
	}
	&.is-focus {
		&:not(.is-disabled) {
			border-color: color-token(primary);
		}
	}
	&.is-disabled {
		textarea {
			cursor: not-allowed;
		}
	}
	&.disabled-resize,
	&.is-resize-none {
		resize: none;
	}
	// 显式方向放在 disabled-resize 后面，业务传 both 时不能被 autoResize 关拖角盖掉
	&.is-resize-horizontal {
		max-width: 100%;
		resize: horizontal;
	}
	&.is-resize-both {
		max-width: 100%;
		resize: both;
	}
}
